var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DC625C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30156 14.3787L12.2426 18.9916C12.4477 19.183 12.7184 19.2897 13 19.2897C13.2816 19.2897 13.5523 19.183 13.7574 18.9916L18.6984 14.3787C19.5297 13.6049 20 12.5194 20 11.3846V11.226C20 9.31467 18.6191 7.68498 16.7352 7.37053C15.4883 7.16271 14.2195 7.57014 13.3281 8.46154L13 8.78967L12.6719 8.46154C11.7805 7.57014 10.5117 7.16271 9.26484 7.37053C7.38086 7.68498 6 9.31467 6 11.226V11.3846C6 12.5194 6.47031 13.6049 7.30156 14.3787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.362d35ade60205867a7426de197259f5.svg";
export { ForwardRef as ReactComponent };